import { assetManager, director } from 'cc';
import { DEBUG } from 'cc/env';
import Game from './Game';
import IPreloader from './IPreloader';
import LoadingTask from './Toolkit/Helper/Loading/LoadingTask/LoadingTask';
import CompositeLoadingTask from './Toolkit/Helper/Loading/LoadingTask/CompositeLoadingTask';
import { ActivityEventName } from './Config/ActivityConfigType';
import { loadCRM } from './BonusLauncher';
import { setCurrentCRMSceneConfig } from './BaseGameLauncher';

export default class PreloadFlow {
    private static _isLoading: boolean = false;

    public static get isLoading(): Readonly<boolean> {
        return this._isLoading;
    }

    /**
     * start preload flow
     * @returns preloading task
     */
    public static start(mainSceneName: string, game: Game, gameBundleName: string = ''): CompositeLoadingTask {
        if (DEBUG) {
            // eslint-disable-next-line no-console
            console.groupCollapsed('Loading Log');
        }
        this._isLoading = true;
        const preloadTask = new CompositeLoadingTask('PreloadFlow');
        const mainPreloader: IPreloader = {
            preload: () => {
                // preload main scene
                const mainScenePreloadTask = preloadTask.addTask(new LoadingTask('PreloadMainScene'));
                if (!gameBundleName) {
                    director.preloadScene(
                        mainSceneName,
                        mainScenePreloadTask.progress.bind(mainScenePreloadTask),
                        mainScenePreloadTask.finish.bind(mainScenePreloadTask),
                    );
                } else {
                    assetManager.loadBundle(gameBundleName, (err, bundle) => {
                        if (err) {
                            mainScenePreloadTask.finish(err);
                            return;
                        }
                        bundle.preloadScene(
                            mainSceneName,
                            mainScenePreloadTask.progress.bind(mainScenePreloadTask),
                            mainScenePreloadTask.finish.bind(mainScenePreloadTask),
                        );
                    });
                }
                return mainScenePreloadTask;
            },
        };
        const subPreloaders: IPreloader[] = [game.i18n, game.audio, game.shader, game.spine, game.tool, ...Object.values(game.bundles)].filter(Boolean);

        mainPreloader
            .preload()
            .waitForStart()
            .then(() => {
                subPreloaders.forEach((subPreloader) => preloadTask.addTask(subPreloader.preload()));
                if (game.config.crm && game.config.waitForCRM) {
                    setCurrentCRMSceneConfig(mainSceneName);
                    preloadTask.addSimpleTask('Crm', loadCRM(false));
                }
                game.event.emit(Game.EVENT_TYPE.PRELOAD_START);
            });

        preloadTask.waitForFinish().then(() => {
            this._isLoading = false;
            game.activity.send(ActivityEventName.Loading, {});
            game.event.emit(Game.EVENT_TYPE.PRELOAD_COMPLETE);
            if (DEBUG) {
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
        });

        return preloadTask;
    }
}
